import React, { useState } from "react";
import ContactForm from "./ContactForm";
import { motion } from "framer-motion";
import { qaData } from "../utility/constains";

const CircleRateQA = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div className="relative flex justify-between items-center p-4 m-5">
      {!isFormVisible && (
        <div className="w-full md:w-2/3 px-6 py-4 lg:bg-[#f0f8ff] rounded-xl shadow-sm lg:shadow-lg">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl font-heading tracking-wider font-semibold mb-7 mt-3 text-gray-700">
              Circle Rate Calculator
            </h1>
            {qaData.map((item, index) => (
              <section key={index} className="mb-8 border-b">
                <motion.div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => toggleAnswer(index)}
                  whileHover={{ scale: 1.02 }}
                >
                  <h2 className="text-xl mb-3 ml-2 px-2 tracking-wide font-body text-gray-700">
                    {item.question}
                  </h2>
                  <span className="text-xl px-3">
                    {openIndex === index ? "-" : "+"}
                  </span>
                </motion.div>
                {openIndex === index && (
                  <motion.p
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    transition={{ duration: 0.5 }}
                    className="text-gray-600 mb-5 ml-2 px-2 leading-7 tracking-wide font-body"
                  >
                    {item.answer}
                  </motion.p>
                )}
              </section>
            ))}
          </motion.div>
        </div>
      )}

      <div className="md:hidden block absolute -right-5 text-center">
        <button
          onClick={toggleFormVisibility}
          className="text-2xl font-bold text-white px-4 text-center py-2 bg-green-700 rounded-full"
        >
          {isFormVisible ? "X" : "<"}
        </button>
      </div>

      {isFormVisible ? (
        <div className="w-full md:w-1/3 px-6 py-4 ">
          <ContactForm />
        </div>
      ) : (
        <motion.div className="hidden md:block md:w-1/3 px-6 py-4 lg:ml-24">
          <ContactForm />
        </motion.div>
      )}
    </div>
  );
};

export default CircleRateQA;
